// import React, { useState, useEffect } from 'react';
// import Axios from 'axios';
// import { useNavigate } from 'react-router-dom';
// import {
//   Flex,
//   Box,
//   Button,
//   useColorModeValue,
//   IconButton,
//   Tooltip,
// } from '@chakra-ui/react';
// import Card from 'components/card/Card';
// import LearnerActivityDataTable from './AssessmentAnalytics';
// import {
//   MdEdit,
//   MdDelete,
//   MdGroupAdd,
//   MdDone,
//   MdClose,
//   MdVideogameAsset,
//   MdVisibility,
// } from 'react-icons/md';

// import { getAllAssessments } from 'utils/activitycontrols/activities';

// import Popup from 'components/alerts/Popup';
// import OnToast from 'components/alerts/toast';
// import { Switch } from '@chakra-ui/react';
// import { HashLoader } from 'react-spinners';
// interface LearnerActivityData {
//   sNo: number;
//   lenUserName: string;
//   lenMail: string;


//   quest: number;
//   competency: string;
//   PreAssessmentScore: number;
//   PostAssessmentScore: number;
//   Improvement: number;
//   Threshold: string;

//   cpCompanyName: string;
//   ctName: string;
//   gameTitle: string;
//   createdDate: any;
//   cohortName: any;
//   started: any;
//   completed: any;
//   progress: any;
//   originalScore: any;
//   finalScore: any;
//   QuestReplay: any;
//   Timespend: any;
//   Lastactive: any;
// }

// interface RowObj {


 
 
  
//   quest: number;
//   competency: string;
//   PreAssessmentScore: number;
//   PostAssessmentScore: number;
//   Threshold: string;

//   sNo: number;
//   lenUserName: string;
//   lenMail: string;
//   cpCompanyName: string;
//   ctName: string;
//   gameTitle: string;
//   createdDate: any;
//   cohortName: any;
//   started: any;
//   completed: any;
//   progress: any;
//   originalScore: any;
//   finalScore: any;
//   Improvement: any;
//   QuestReplay: any;
//   Timespend: any;
//   Lastactive: any;
// }

// interface LearnerActivityDataTableProps {
//   data: RowObj[];
// }

// const CreatorCreation: React.FC = () => {
//   const storage = JSON.parse(localStorage.getItem('user'));

//   const UserRole = storage.data.role;
//   const [apiData, setApiData] = useState<LearnerActivityData[]>([]);

//   const [gameNames, setGames] = useState([]);
//   const [cohorts, setcohort] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [companyNames, setCompany] = useState([]);
//   const [alert, setAlert] = useState(false);
//   const [isOpen, setIsOpen] = useState(false);
//   const [isConfirm, setIsConfirm] = useState(false);
//   const [msg, setMsg] = useState<string>('');
//   const [toastStatus, setToastStatus] = useState<string>('');
//   const [deleteId, setDeleteId] = useState<number>(0);

//   const [isToggled, setIsToggled] = useState(false);

//   const fetchData = async () => {
//     setLoadingdata(true);

//     try {
//       const resultfromlearners = await getAllAssessments();

//       if (resultfromlearners?.status !== 'Success') {
//         console.log('getCreator Error:', resultfromlearners?.message);
//         setLoadingdata(false);
//         return;
//       }

//       // Transform the data here using map
//       const dataArray = Array.isArray(resultfromlearners.data)
//         ? resultfromlearners.data
//         : Object.values(resultfromlearners.data);

//       // Transform the array using .map()
//       const transformedData = dataArray.map((item: any, index: number) => ({
//         sNo: index + 1, // Add a serial number based on index
//         lenUserName: item.lenUserName || '',
//         lenMail: item.lenMail || '',
//         cpCompanyName: item.cpCompanyName || '',
//         ctName: item.ctName || '',
//         gameTitle: item.gameTitle || '',
//         createdDate: item.createdDate || '',
//         cohortName: item.cohortName || '-',
//         started: item.started || 'Not-Yet',
//         completed: item.completed || 'Inprogress',
//         progress: item.progress || '0%',
//         Improvement: item.Improvement || '0%',
//         QuestReplay: item.QuestReplay || '0',
//         Timespend: item.Timespend || '0:00',
//         Lastactive: item.Lastactive || '0:00',     
//     competency: `${item.quest}. ${item.competency}`,
//     PreAssessmentScore: `${item.PreAssessmentScore}`,
//     PostAssessmentScore: `${item.PostAssessmentScore}`,
  
//     Threshold: item.Threshold,
         




//       }));

//       setApiData(
//         resultfromlearners.data.map((item: any) => ({
//           ...item,
//           sNo: item.sNo,
//           lenUserName: item.lenUserName,
//           lenMail: item.lenMail,
//           cpCompanyName: item.cpCompanyName,
//           ctName: item.ctName,
//           gameTitle: item.gameTitle,
//           createdDate: item.createdDate,
//           cohortName: item.cohortName,
//           started: item.started,
//           completed: item.completed,
//           progress: item.progress,
//           // originalScore: isToggled
//           //   ? item.originalScore.playedScore
//           //   : item.originalScore.percentage,
//           // finalScore: isToggled
//           //   ? item.finalScore.playedScore
//           //   : item.finalScore.percentage,

//           Improvement: item.Improvement,
//           QuestReplay: item.QuestReplay,
//           Timespend: item.Timespend,
//           Lastactive: item.Lastactive,
//         })),
//       ); // Update state with transformed data
//     } catch (error) {
//       console.error('Error fetching data:', error);
//     } finally {
//       setLoadingdata(false);
//     }
//   };

//   const [formData, setFormData] = useState({
//     lenStatus: '',
//   });
//   const [openCoharts, setOpenCoharts] = useState(false);
//   const [openGame, setOpenGame] = useState(false);
//   const [learnerId, setLearnerId] = useState<number | null>(null);
//   const [loadingdata, setLoadingdata] = useState(false);

//   const transformData = (apiData: any) => {
//     const dataArray = Array.isArray(apiData)
//       ? apiData
//       : apiData.rows || Object.values(apiData);

//     if (!Array.isArray(dataArray)) {
//       return [];
//     }

//     return dataArray.map((data, index) => ({
//       ...data,
//       sNo: index + 1,
//       lenUserName: data.lenUserName ?? '',
//       lenMail: data.lenMail ?? '',
//       cpCompanyName: data.cpCompanyName ?? '',
//       ctName: data.ctName ?? '',
//       gameTitle: data.gameTitle ?? '',
//       createdDate: data.createdDate ?? '',
//       cohortName: data.cohortName ?? '-',
//       started: data.started ?? 'Not-Yet',
//       completed: data.completed ?? 'Inprogress',
//       // progress: data.progress ?? '0%',
//       progress: `${Math.floor(data.progress * 100) ?? 0}%`,
//       // originalScore: isToggled
//       //   ? data.originalScore.playedScore
//       //   : data.originalScore.percentage,
//       // finalScore: isToggled
//       //   ? data.finalScore.playedScore
//       //   : data.finalScore.percentage,

//       Improvement: data.Improvement ?? '0%',
   
//     }));
//   };

//   const transformedData: RowObj[] = transformData(apiData);

//   return (
//     <>
//       <Box mb={{ base: '135px', md: '100px', xl: '100px' }}></Box>

//       {loadingdata && (
//         <div
//           style={{
//             position: 'fixed',
//             top: 0,
//             left: 0,
//             width: '100%',
//             height: '100%',
//             zIndex: 9999,
//             display: 'flex',
//             justifyContent: 'center',
//             alignItems: 'center',
//             backdropFilter: 'blur(10px)',
//           }}
//         >
//           <HashLoader color="#3b38e0" />
//         </div>
//       )}
//       <LearnerActivityDataTable
//         data={transformedData}
//         setApiData={setApiData}
//         setCompany={setCompany}
//         setGames={setGames}
//         setcohort={setcohort}
//         apiData={apiData}
//         isToggled={isToggled}
//         setIsToggled={setIsToggled}
//       />

//       {isOpen ? (
//         <Popup
//           setDeleteId={setDeleteId}
//           setIsConfirm={setIsConfirm}
//           setIsOpen={setIsOpen}
//           msg={''}
//           setmsg={''}
//         />
//       ) : null}
//       {alert ? (
//         <OnToast msg={msg} status={toastStatus} setAlert={setAlert} />
//       ) : null}
//     </>
//   );
// };

// export default CreatorCreation;


import React, { useState, useEffect } from 'react';
import Axios from 'axios';
import { useNavigate } from 'react-router-dom';
import {
  Flex,
  Box,
  Button,
  useColorModeValue,
  IconButton,
  Tooltip,
} from '@chakra-ui/react';
import Card from 'components/card/Card';
import LearnerActivityDataTable from './AssessmentAnalytics';
import {
  MdEdit,
  MdDelete,
  MdGroupAdd,
  MdDone,
  MdClose,
  MdVideogameAsset,
  MdVisibility,
} from 'react-icons/md';

import { getAllAssessments } from 'utils/activitycontrols/activities';

import Popup from 'components/alerts/Popup';
import OnToast from 'components/alerts/toast';
import { Switch } from '@chakra-ui/react';
import { HashLoader } from 'react-spinners';
interface LearnerActivityData {
  sNo: number;
  lenUserName: string;
  lenMail: string;


  quest: number;
  competency: string;
  PreAssessmentScore: number;
  PostAssessmentScore: number;
  Improvement: number;
  Threshold: string;

  cpCompanyName: string;
  ctName: string;
  gameTitle: string;
  createdDate: any;
  cohortName: any;
  started: any;
  completed: any;
  progress: any;
  originalScore: any;
  finalScore: any;
  QuestReplay: any;
  Timespend: any;
  Lastactive: any;
}

interface RowObj {


 
 
  
  quest: number;
  competency: string;
  PreAssessmentScore: number;
  PostAssessmentScore: number;
  Threshold: string;

  sNo: number;
  lenUserName: string;
  lenMail: string;
  cpCompanyName: string;
  ctName: string;
  gameTitle: string;
  createdDate: any;
  cohortName: any;
  started: any;
  completed: any;
  progress: any;
  originalScore: any;
  finalScore: any;
  Improvement: any;
  QuestReplay: any;
  Timespend: any;
  Lastactive: any;
}

interface LearnerActivityDataTableProps {
  data: RowObj[];
}

const CreatorCreation: React.FC = () => {
  const storage = JSON.parse(localStorage.getItem('user'));

  const UserRole = storage.data.role;
  const [apiData, setApiData] = useState<LearnerActivityData[]>([]);

  const [gameNames, setGames] = useState([]);
  const [cohorts, setcohort] = useState([]);
  const [loading, setLoading] = useState(true);
  const [companyNames, setCompany] = useState([]);
  const [alert, setAlert] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [isConfirm, setIsConfirm] = useState(false);
  const [msg, setMsg] = useState<string>('');
  const [toastStatus, setToastStatus] = useState<string>('');
  const [deleteId, setDeleteId] = useState<number>(0);

  const [isToggled, setIsToggled] = useState(false);

  // const fetchData = async () => {
  //   setLoadingdata(true);

  //   try {
  //     const resultfromlearners = await getAllAssessments();

  //     if (resultfromlearners?.status !== 'Success') {
  //       console.log('getCreator Error:', resultfromlearners?.message);
  //       setLoadingdata(false);
  //       return;
  //     }

  //     // Transform the data here using map
  //     const dataArray = Array.isArray(resultfromlearners.data)
  //       ? resultfromlearners.data
  //       : Object.values(resultfromlearners.data);

  //     // Transform the array using .map()
  //     const transformedData = dataArray.map((item: any, index: number) => ({
  //       sNo: index + 1, // Add a serial number based on index
  //       lenUserName: item.lenUserName || '',
  //       lenMail: item.lenMail || '',
  //       cpCompanyName: item.cpCompanyName || '',
  //       ctName: item.ctName || '',
  //       gameTitle: item.gameTitle || '',
  //       createdDate: item.createdDate || '',
  //       cohortName: item.cohortName || '-',
  //       started: item.started || 'Not-Yet',
  //       completed: item.completed || 'Inprogress',
  //       progress: item.progress || '0%',
  //       Improvement: item.Improvement || '0%',
  //       QuestReplay: item.QuestReplay || '0',
  //       Timespend: item.Timespend || '0:00',
  //       Lastactive: item.Lastactive || '0:00',     
  //   competency: `${item.quest}. ${item.competency}`,
  //   PreAssessmentScore: `${item.PreAssessmentScore}`,
  //   PostAssessmentScore: `${item.PostAssessmentScore}`,
  
  //   Threshold: item.Threshold,
         




  //     }));

  //     setApiData(
  //       resultfromlearners.data.map((item: any) => ({
  //         ...item,
  //         sNo: item.sNo,
  //         lenUserName: item.lenUserName,
  //         lenMail: item.lenMail,
  //         cpCompanyName: item.cpCompanyName,
  //         ctName: item.ctName,
  //         gameTitle: item.gameTitle,
  //         createdDate: item.createdDate,
  //         cohortName: item.cohortName,
  //         started: item.started,
  //         completed: item.completed,
  //         progress: item.progress,
  //         // originalScore: isToggled
  //         //   ? item.originalScore.playedScore
  //         //   : item.originalScore.percentage,
  //         // finalScore: isToggled
  //         //   ? item.finalScore.playedScore
  //         //   : item.finalScore.percentage,

  //         Improvement: item.Improvement,
  //         QuestReplay: item.QuestReplay,
  //         Timespend: item.Timespend,
  //         Lastactive: item.Lastactive,
  //       })),
  //     ); // Update state with transformed data
  //   } catch (error) {
  //     console.error('Error fetching data:', error);
  //   } finally {
  //     setLoadingdata(false);
  //   }
  // };

  const [formData, setFormData] = useState({
    lenStatus: '',
  });
  const [openCoharts, setOpenCoharts] = useState(false);
  const [openGame, setOpenGame] = useState(false);
  const [learnerId, setLearnerId] = useState<number | null>(null);
  const [loadingdata, setLoadingdata] = useState(false);

  const transformData = (apiData: any) => {
    const dataArray = Array.isArray(apiData)
      ? apiData
      : apiData.rows || Object.values(apiData);

    if (!Array.isArray(dataArray)) {
      return [];
    }

    return dataArray.map((data, index) => ({
      ...data,
      // sNo: index + 1,
       sNo: data.sNo, 
      lenUserName: data.lenUserName ?? '',
      lenMail: data.lenMail ?? '',
      cpCompanyName: data.cpCompanyName ?? '',
      ctName: data.ctName ?? '',
      gameTitle: data.gameTitle ?? '',
      createdDate: data.createdDate ?? '',
      cohortName: data.cohortName ?? '-',
      started: data.started ?? 'Not-Yet',
      completed: data.completed ?? 'Inprogress',
      // progress: data.progress ?? '0%',
      progress: `${Math.floor(data.progress * 100) ?? 0}%`,
      // originalScore: isToggled
      //   ? data.originalScore.playedScore
      //   : data.originalScore.percentage,
      // finalScore: isToggled
      //   ? data.finalScore.playedScore
      //   : data.finalScore.percentage,

      Improvement: data.Improvement ?? '0%',
   
    }));
  };

  const transformedData: RowObj[] = transformData(apiData);

  return (
    <>
      <Box mb={{ base: '135px', md: '100px', xl: '100px' }}></Box>

      {loadingdata && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            zIndex: 9999,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backdropFilter: 'blur(10px)',
          }}
        >
          <HashLoader color="#3b38e0" />
        </div>
      )}
      <LearnerActivityDataTable
        data={transformedData}
        setApiData={setApiData}
        setCompany={setCompany}
        setGames={setGames}
        setcohort={setcohort}
        apiData={apiData}
        isToggled={isToggled}
        setIsToggled={setIsToggled}
      />

      {isOpen ? (
        <Popup
          setDeleteId={setDeleteId}
          setIsConfirm={setIsConfirm}
          setIsOpen={setIsOpen}
          msg={''}
          setmsg={''}
        />
      ) : null}
      {alert ? (
        <OnToast msg={msg} status={toastStatus} setAlert={setAlert} />
      ) : null}
    </>
  );
};

export default CreatorCreation;
